import pageActions from '../page/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case pageActions.GO_SUCCESS:
      return action.payload.data.meta.offers || {};
    default:
      return state;
  }
};
